module.exports = __webpack_public_path__ + "static/media/icon-circle-instagram.62cfad2c.svg";